import EnergiaSolarPerguntasFrequentes from '../components/templates/EnergiaSolarPerguntasFrequentes';

export default function EnergiaSolarPerguntasFrequentesPage() {
  return <EnergiaSolarPerguntasFrequentes />;
}

export async function getStaticProps() {
  return {
    props: {
      energiaSolar: true,
    },
  };
}
